<script lang="ts">
      import { news, type News } from '$lib/data/dummy'
      import ImageElement from '../gallery/ImageElement.svelte'
      import { getLocaleContext } from '../locale/ts/Locale.svelte'

      let { gridItem } = $props()
      let { populate } = $derived(gridItem)
      let { value } = $derived(populate)
      let item = $derived({ value })

      const locale = getLocaleContext()
      let r = Math.random() * 100 > 55

      //grid-cols-1
      //md:grid-cols-2
      //lg:grid-cols-4
      //xl:grid-cols-4
      //2xl:grid-cols-4
      //3xl:grid-cols-6
      //4xl:grid-cols-8

      function formatDate(date: string) {
            if (!date) return ''
            const d = new Date(date)
            let r = ''
            r += d.getDate()
            r += '/'
            r += d.getMonth() + 1
            r += '/'
            r += d.getFullYear()

            return r
      }

      function formatCategories(categories) {
            return categories?.map((cat) => cat.singular).join(', ')
      }
</script>

<a href="{locale.getLocaleLinkFromTouple(item.value.localeSlugs)}" class="newsItemContainer @container rounded-xl bg-[#f2F2F2] overflow-hidden flex h-full" style="grid-area: {gridItem.gridArea}">
      {#if gridItem.orientation == 'horizontal'}
            <div class="newsItem w-full h-full flex flex-col md:flex-row">
                  <!-- TODO: fix missing image  -->
                  <div class="w-full md:w-1/2 h-full bg-[#ffffff33]">
                        <ImageElement image={item.value?.info?.image ?? null} respectAspect={false} elementClass=" object-cover h-full w-full" class="object-cover w-full h-full"></ImageElement>
                  </div>

                  <div class="w-full md:w-1/2 h-full flex-shrink-0 flex flex-col mt-auto px-6 md:px-8 pt-4 pb-8 bg-[#f2F2F2]">
                        <div class="date font-['nunito-sans'] text-sm text-[#414141]">
                              <p>{formatDate(item.value.createdAt)}</p>
                              <p>{formatCategories(item.value.categories)}</p>
                        </div>
                        <h1 class="block text-xl mb-2">{item.value.title}</h1>
                        <div class="content font-['nunito-sans'] text-[#414141]">
                              <p>{item.value?.info?.description}</p>
                        </div>
                  </div>
            </div>
      {:else if gridItem.orientation == 'vertical'}
            <div class="newsItem w-full h-full flex flex-col">
                  <!-- TODO: fix missing image  -->
                  <div class="w-full h-1/2 bg-[#ffffff33]">
                        <ImageElement image={item.value?.info?.image ?? null} respectAspect={false} elementClass=" object-cover h-full w-full" class="object-cover w-full h-full"></ImageElement>
                  </div>

                  <div class="h-1/2 w-full flex flex-col mt-auto px-6 md:px-8 pt-4 pb-8 bg-[#f2F2F2]">
                        <div class="date font-['nunito-sans'] text-sm text-[#414141]">
                              <p>{formatDate(item.value.createdAt)}</p>
                              <p>{formatCategories(item.value.categories)}</p>
                        </div>
                        <h1 class="block text-xl mb-2">{item.value.title}</h1>
                        <div class="content font-['nunito-sans'] text-[#414141]">
                              <p>{item.value.info.description}</p>
                        </div>
                  </div>
            </div>
      {/if}
</a>

<style lang="postcss">
      .newsItem {
            @apply flex-shrink rounded-xl overflow-hidden shadow-md;
            /*@apply flex-shrink border-[2px] border-[#00000044] rounded-xl;*/
            transition: transform 0.3s ease-in-out;
            /*box-shadow: 0px 2px 9px 0px #dedede33;*/
      }
      .newsItem:hover {
            transform: scale(1);
      }

      .newsItem h1 {
            transition: color 0.4s ease-in-out;
      }

      .newsItem:hover h1 {
            color: #00d314;
      }

      .newsItemContainer {
            /*@apply;*/
      }

      .backdrop {
            /*background: rgb(255,255,255, 200);*/
            /*background: linear-gradient(0deg, rgba(255, 255, 255, 0.908) 97%, rgba(255, 255, 255, 0.117) 100%);*/
      }
</style>
